import logo from './logo.png';
import './App.css';
import Footer from './Footer';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

// Import your pages
import Home from "./pages/Home";
import Noha from './pages/Noha';
import Salam from './pages/Salam';
import Marsiya from './pages/Marsiya';
import Contact from "./pages/Contact";

function App() {
  // Function to close the menu
  const closeMenu = () => {
    const nav = document.getElementById("navbarNav");
    if (nav && nav.classList.contains("show")) {
      const bsCollapse = new window.bootstrap.Collapse(nav, { toggle: true });
      bsCollapse.hide();
    }
  }
  return (
    <div>
      <Router>
        {/* Navigation Menu */}
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
          <div className="container">
            {/* Logo */}
            <Link className="navbar-brand" to="/">
              <img src={logo} className="mt-2 mb-2" style={{ width: "200px" }} alt="Bayaz-e-Gham" />
            </Link>

            {/* Toggler */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Links */}
            <div className="collapse navbar-collapse" id="navbarNav">
              <div className="navbar-nav ms-auto">
                <Link className="nav-link" to="/" onClick={closeMenu}>Home</Link>
                <Link className="nav-link" to="/noha" onClick={closeMenu}>Noha</Link>
                <Link className="nav-link" to="/salam" onClick={closeMenu}>Salam</Link>
                <Link className="nav-link" to="/marsiya" onClick={closeMenu}>Marsiya</Link>
                <Link className="nav-link" to="/contact" onClick={closeMenu}>Contact</Link>
              </div>
            </div>
          </div>
        </nav>


        {/* Page Routes */}
        <div className="mt-4">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/noha" element={<Noha />} />
            <Route path="/salam" element={<Salam />} />
            <Route path="/marsiya" element={<Marsiya />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
      </Router>
      <Footer />
    </div>
  );
}

export default App;
